import { CONTACT_EMAIL_BASE64 } from "@/app/lib/seo/siteConfig";

/** The primary call to action across the marketing site: the header, and every
    hero and closing section. Self-serve registration. Named for what it does,
    so a change of label is one line here. */
export const SIGNUP_CTA = {
  label: "Start free",
  href: "/auth/register",
  gtm: {
    event: "click_cta",
    text: "Start free",
  },
} as const;

/** The secondary action beside Start free: an email to the founders' inbox,
    built in the browser (`ProtectedEmailButton`). At this stage a founder reads
    every message, which is what the label promises. It renders as a plain
    anchor, never Next's Link, which is for routes inside the app. */
export const TALK_TO_HUMAN_CTA = {
  label: "Talk to a human",
  email: CONTACT_EMAIL_BASE64.founder,
} as const;

/** The marketing header's height, for scroll math in script. CSS reads the
    same number as `--marketing-header-height` (`layout.module.css`). */
export const STICKY_HEADER_HEIGHT = 60;

/** Marks a full-bleed dark section. The header watches for it and wears the
    band's color while one sits under the header's bottom edge. */
export const DARK_BAND_ATTRIBUTE = "data-dark-band";

/** The page that opens on a dark band (the homepage's hero is a `DarkBand`).
    The layout's header cannot see the page on the server, so it renders dark
    here until the bands report. A page that stops or starts opening dark
    needs this changed; until it is, that page's header snaps to the right
    tone once its bands report. */
export const DARK_HEADER_PATH = "/";

/** The terms Start free comes with, said once as the lede of the homepage's
    close, where the reader is deciding. */
export const SIGNUP_PROMISE = "Start free. No credit card. No demo. No sales call.";

/** The closing ask on the platform page, pointing at the same first step the
    homepage offers: drop in your plan. */
export const CLOSING_CTA = {
  heading: "See it run on your own plan",
  body: "The fastest way to understand Orgtools is to drop in your plan and watch it find the decisions it depends on.",
} as const;
